import { createReducer } from "redux-create-reducer";

const initialState = {};

export const categoryReducer = createReducer(initialState, {
    "CATEGORIES": (state, action) => {
        return {...state, categories: action.categories};
    }
});
